/**
 * O estado do telefone, sem o JsSIP: o botão da barra do topo lê daqui e fica
 * no pacote principal leve. O motor (useTelefone.js, com o JsSIP) só chega
 * junto com o Telefone.vue, que carrega depois do painel.
 */
import { reactive, readonly } from 'vue';

export const estado = reactive({
  // inicio | sem_ramal | conectando | pronto | outra_aba | erro
  fase: 'inicio',
  erro: '',
  ramal: null,
  // Até DUAS chamadas (como as duas teclas de linha de um aparelho de mesa):
  // a que está à frente (`ativaId`) e a outra — em espera, tocando por cima
  // ou sendo consultada para uma transferência.
  chamadas: [],
  ativaId: null,
  recentes: [],
  equipe: [],
  painelAberto: false,
  // pedido de ligação vindo de fora do telefone (botão "Ligar" do chat, da
  // ficha do contato): o Telefone.vue repassa ao motor
  pedido: null,
  // a que está à frente: é a que o cartão, o botão e o painel mostram
  get chamada() {
    return this.chamadas.find(c => c.id === this.ativaId) || null;
  },
  // a outra linha, se houver
  get outra() {
    return this.chamadas.find(c => c.id !== this.ativaId) || null;
  },
});

export const useTelefone = () => readonly(estado);

export const abrirPainel = (aberto = !estado.painelAberto) => {
  estado.painelAberto = aberto;
};

// "Ligar" de qualquer tela. O número vai como está no advup (+55 27 9…): quem
// converte para o formato da operadora é o PBX (advup_saida).
export const ligarDaTela = (numero, nome = '') => {
  if (!numero || estado.fase !== 'pronto') return false;
  estado.pedido = { numero, nome, em: Date.now() };
  return true;
};

// Só em desenvolvimento: o teste de ponta a ponta do laboratório
// (deployment/telefonia/laboratorio/testar-navegador.sh) lê o estado por aqui —
// importar o arquivo pelo endereço pode pegar outra cópia (carimbo do Vite).
if (import.meta.env.DEV) window.advupTelefone = estado;
